import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import {
  EventTabs,
  IEventForm,
} from 'components/organisms/forms/event/EventForm';
import { FormikHelpers } from 'formik';
import { useParamId } from 'hooks/useParamId';
import eventMiddleware from 'middleware/event';
import { useTranslation } from 'react-i18next';
import { PiIdentificationCard, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetEvent, useUpdateEvent } from 'services/events';
import { STATUS } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getLastPathname } from 'utils/navbar/getParentPathname';

const eventInitialValues: IEventForm = {
  version: 0,
  id: '',
  name: '',
  status: STATUS.draft,
  startDate: new Date().toISOString(),
  endDate: new Date().toISOString(),
  labels: [],
};

const EditEvent = () => {
  const eventId = useParamId('event');
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const updateEvent = useUpdateEvent();

  const { data: event, isLoading } = useGetEvent(eventId);

  const onEditEvent = async (
    values: IEventForm,
    helpers: FormikHelpers<IEventForm>
  ) => {
    const eventData = eventMiddleware.formToUpdateQuery(values);

    await updateEvent.mutateAsync(eventData, {
      onSuccess: () => {
        helpers.setSubmitting(false);
        navigate(`/event/${eventId}/${getLastPathname(pathname)}`);
      },
      onError: () => {
        helpers.setSubmitting(false);
      },
    });
  };

  return (
    <Form.Event
      i18nextPrefix='event'
      initialValues={
        event
          ? eventMiddleware.queryToForm(event)
          : eventInitialValues
      }
      disableTabs={[
        EventTabs.income,
        EventTabs.costs,
        EventTabs.statistics,
      ]}
      onSubmit={onEditEvent}
      status={{ isLoading }}
      customBackItem={
        <Button
          type='button'
          onlyIcon
          onClick={() => {
            event &&
              navigate(`/event/${eventId}/${getLastPathname(pathname)}`, {
                replace: true,
              });
          }}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.save')} />
          <Button.Icon icon={<PiIdentificationCard />} />
        </Button>
      }
    />
  );
};

export default EditEvent;
